// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skill__items {\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 10px;\n  background-color: #e8eafd;\n  color: #2a41e8;\n  border-radius: 4px;\n  flex-wrap: wrap;\n}\n\n.skill__items p {\n  margin: 0 !important;\n  padding: 0 5px !important;\n}\n\n.skill__items img {\n  cursor: pointer;\n  height: 1.2rem;\n  width: 1.2rem;\n}\n", ""]);
// Exports
module.exports = exports;
